export default __webpack_public_path__ + "static/media/shattered_earth_icon.f9117a10.png";